import { render, staticRenderFns } from "./SmartPillboxSetting.vue?vue&type=template&id=b2e33ad0&scoped=true"
import script from "./SmartPillboxSetting.vue?vue&type=script&lang=js"
export * from "./SmartPillboxSetting.vue?vue&type=script&lang=js"
import style0 from "./SmartPillboxSetting.vue?vue&type=style&index=0&id=b2e33ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e33ad0",
  null
  
)

export default component.exports